/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React, {useEffect, useState} from 'react';
import makeAnimated from 'react-select/animated';

import "../../CSS/DataModal.css";
import "react-datepicker/dist/react-datepicker.css";
import CommonModal from "../CommonModal/CommonModal";
import PropTypes from "prop-types";

const animatedComponents = makeAnimated();

function FalsePositiveModal({show, onClick, falsePositiveOptions, onYes}) {
    const [selectedOption, setSelectedOption] = useState(falsePositiveOptions && falsePositiveOptions.length > 0 ? falsePositiveOptions[0] : null);

    useEffect(() => {
        if (falsePositiveOptions && falsePositiveOptions.length > 0 && selectedOption == null) {
            setSelectedOption(falsePositiveOptions[0]);
        }
    }, [falsePositiveOptions, selectedOption]);
    
    const onChangeAction = (option) => {
        setSelectedOption(option);
    }

    const getOptionLabel = (option) => {
        return (option.name)
    }

    const getOptionValue = (option) => {
        return (option.id)
    }

    const onContinue = () => {
        onYes(selectedOption);
        setSelectedOption(null);
    }

    let modalContent = <div>
        <label htmlFor="description" ><b>False Positive Reasoning:</b> </label>

        {falsePositiveOptions?.length > 0 ? falsePositiveOptions?.map((option) => (
            <label key={getOptionValue(option)} className="d-block">
                <input
                    type="radio"
                    className="margin-right-5"
                    checked={selectedOption === option}
                    onChange={() => onChangeAction(option)}
                />
                {getOptionLabel(option)}
            </label>
        )) : null}
    </div>

    if (show) {
        return (
            <div>
                <CommonModal show={show} onYes={onContinue} onClick={onClick} content={modalContent} title={'False Positive Reason'} />
            </div>
        )
    }
    else {
        return null;
    }
}

FalsePositiveModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    falsePositiveOptions: PropTypes.array,
    onYes: PropTypes.func.isRequired
};

export default FalsePositiveModal;